import React, { Component } from "react";
import AntdTimeline, {TimelineProps} from "antd/lib/timeline";
import "antd/lib/timeline/style";

const { Item } = AntdTimeline;
export default class Timeline extends Component<TimelineProps> {
  static Item = Item;
  render() {
    return <AntdTimeline {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/timeline/index.tsx